import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth.jsx';
import { App } from './App.jsx';

// Load in dependency order:
//  1. tokens.css  — CSS custom properties every other file consumes
//  2. global.css  — uses the tokens
import './styles/tokens.css';
import './styles/global.css';
import './styles/chunk-2c.css';
import './styles/settings.css';
import './styles/id-cards.css';
import './components/cards/banner-cropper.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
